<template>
  <div class="about">
    <div>
      基础金价：{{basicsPrice}}元/克&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      基础银价：{{silverPrice}}元/克&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- 金条价格 -->
      金条价格：{{costPrice}}元/克
    </div>
    <div class="custom-wrapper">
      <div class="input-wrapper">
        自定义金价: <Input v-model="customGold" placeholder="输入自定义金价"  class="input" />
        自定义银价: <Input v-model="customSilver" placeholder="输入自定义银价" class="input"/>
        自定义金条价格: <Input v-model="customCost" placeholder="输入自定义金条价格" class="input"/>
        <Button type="primary" @click="updataCustomPrice">更新</Button>

      </div>
    </div>

    <Table :columns="columns" :data="list"></Table>

    <div class="add">
      <Button type="primary" @click="createModal=true">增加模板</Button>
    </div>

    <div>
     
      <div class="tip">
        tip:
        <br/>
        在金银类产品的价格计算中，基础金价以上海黄金交易所黄金牌价（ x ）表示，基础银价以白银牌价（ y ）表示，基础金条以金条牌价（ b ）表示,同时支持自定义金价（ z ）、自定义银价（ w ）和 自定义金条价格（ c ）。价格模板公式以 | 分隔，例如 (x+20)*1.2|(y+20)*1.2 ，可根据需求灵活设定。例如，黄金吊坠的克数为 20 克，金价为黄金牌价 x 加 156 附加费，利润为 30%，则价格模板公式为 (x+156)*1.3 。在此基础上，新增 s1 代表黄金总销售工费（金重 × 销售工费）， s2 代表白银总销售工费（银重 × 销售工费），公式可扩展为 (x+20+s1)*1.2|(y+20+s2)*1.2 ，系统默认克数，无需填写。
      </div>
     
    </div>
    <Modal v-model="updateModal" title="更新模板" @on-ok="update">
      <Input v-model="updateName" placeholder="输入名称" style="margin-bottom: 5px"/>
      <Input v-model="updateformula" placeholder="输入模板"/>
    </Modal>
    <Modal v-model="createModal" title="创建模板" @on-ok="create">
      <Input v-model="createName" placeholder="输入名称" style="margin-bottom: 5px"/>
      <Input v-model="createformula" placeholder="输入模板"/>
    </Modal>

     <Spin size="large" fix v-if="spinShow">
       <!-- <div>正在更新中,请稍等~</div> -->
     </Spin>
  </div>
</template>

<script>
import { Button, Table, Modal, Input, Spin} from "iview";
import { getPrice } from "@/api/goldPrice";
import {
  getTemplate,
  deleteTemplate,
  updateTemplate,
  createTemplate,
  getParameter,
  createParameter,
  updateParameter,
  deleteParameter,
  allUpdate
} from "@/api/templateReq";
export default {
  name: "about",

  components: {
    Button,
    Table,
    Modal,
    Input,
    Spin
  },

  data() {
    return {
      columns: [
        {
          title: "模板Id",
          key: "goods_price_template_id"
        },
        {
          title: "模板名称",
          key: "name"
        },
        {
          title: "模板公式",
          key: "formula"
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                Button,
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.updateTem(params.row);
                    }
                  }
                },
                "更新"
              ),
              h(
                Button,
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeTem(params.row.goods_price_template_id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      list: [],
      updateModal: false,
      updateId: null,
      updateName: "",
      updateformula: "",
      createModal: false,
      createName: "",
      createformula: "",
      basicsPrice: '',
      silverPrice: '',
      customGold: '',
      customSilver: '',
      customCost: '',
      customGoldType: 'create',
      customSilverType: 'create',
      customCostType: 'create',
      spinShow: false,
      costPrice: ''
    };
  },

  created() {
    this.getTemplateList();
    getParameter().then(res=>{   
        res.data.data.forEach(element => {
          if(element.key==='z'){
            this.customGoldType = element.id;
            this.customGold = element.value;
          }
          if(element.key==='w'){
            this.customSilverType = element.id;
            this.customSilver = element.value;
          }
          if(element.key==='c'){
            this.customCostType = element.id;
            this.customCost = element.value;
          }
      })
    })
  },

  activated() {
     getPrice('JO_9754').then(res => {
      this.silverPrice = (res.data.data['JO_9754'].q63 / 1000).toFixed(2); 
      this.basicsPrice = res.data.data.base_price;
      this.costPrice = res.data.data.perfect_gold.cost;
    });


  },

  methods: {
    getTemplateList() {
      getTemplate().then(res => {
        this.list = res.data.data;
      });
    },
    updateTem(row) {
      this.updateId = row.goods_price_template_id;
      this.updateName = row.name;
      this.updateformula = row.formula;
      this.updateModal = true;
    },
    removeTem(id) {
      this.$Modal.confirm({
        title: "是否确认删除？",
        onOk: () => {
          deleteTemplate(id).then(() => {
            this.$Message.success("删除成功");
            this.getTemplateList()
          });
        }
      });
    },
    update() {
      updateTemplate({
        goods_price_template_id: this.updateId,
        formula: this.updateformula,
        name: this.updateName
      }).then(res => {
        this.getTemplateList() 
        this.$Message.success("更新成功");
      });
    },
    create() {
      createTemplate(this.createformula, this.createName).then(() => {
        this.$Message.success("创建成功");
        this.getTemplateList()
      });
    },

    //更新自定义价格
    updataCustomPrice(){
      if(this.customGold==='' || this.customSilver==='' || this.customCost===''){
        this.$Message.error('请填写完整自定义金价，自定义银价及自定义金条价格');
        return
      }
      this.spinShow = true;
      // if(this.customGoldType === 'create' && this.customSilverType === 'create' && this.customCostType === 'create'){
      //   let createGold = createParameter('自定义金价', 'z', this.customGold);
      //   let createSilver = createParameter('自定义银价', 'w', this.customSilver);
      //   let createCost = createParameter('自定义金条价格', 'c', this.customCost);
      //   Promise.all([createGold, createSilver, createCost]).then( ()=> {
      //     // this.allUpdatePrice()
      //   }).catch(()=>{
      //     this.$Message.error('更新失败，请重试');
      //     this.spinShow = false;
      //   });
      // }else {
      //   let updateGold = updateParameter(this.customGoldType, '自定义金价', 'z', this.customGold);
      //   let updateSilver = updateParameter(this.customSilverType, '自定义银价', 'w', this.customSilver);
      //   let updateCost = updateParameter(this.customCostType, '自定义金条价格', 'c', this.customCost);
      //   Promise.all([updateGold, updateSilver, updateCost]).then( ()=> {
      //     this.allUpdatePrice()  
      //   }).catch(()=>{
      //     this.$Message.error('更新失败，请重试');
      //     this.spinShow = false;
      //   });
      // }
      // 如果type为create，则创建参数
      let apiArr = []
      if(this.customGoldType === 'create'){
        apiArr.push(createParameter('自定义金价', 'z', this.customGold));
      }else{
        apiArr.push(updateParameter(this.customGoldType, '自定义金价', 'z', this.customGold));
      }
      if(this.customSilverType === 'create'){
        apiArr.push(createParameter('自定义银价', 'w', this.customSilver));
      }else{
        apiArr.push(updateParameter(this.customSilverType, '自定义银价', 'w', this.customSilver));
      }
      if(this.customCostType === 'create'){
        apiArr.push(createParameter('自定义金条价格', 'c', this.customCost));
      }else{
        apiArr.push(updateParameter(this.customCostType, '自定义金条价格', 'c', this.customCost));
      }
      Promise.all(apiArr).then( ()=> {
        // this.allUpdatePrice()
      }).catch(()=>{
        this.$Message.error('更新失败，请重试');
        this.spinShow = false;
      }).finally(()=>{
        this.$Message.success('更新成功');
        this.spinShow = false;
      });
    },

    //一键更新
    // allUpdatePrice(){
    //   let firstArr = this.list.filter(ele=>{
    //     return ele.formula.indexOf('z')>-1 || ele.formula.indexOf('w')>-1 || ele.formula.indexOf('c')>-1
    //   })
    //   if(firstArr.length===0){
    //     this.$Message.error('没有对应公式');
    //     this.spinShow = false;
    //     return
    //   }
    //   let paramsArr = [];
    //   // 自定义金价
    //   var z = Number(this.customGold)
    //   // 自定义银价
    //   var w = Number(this.customSilver);
    //   // 自定义金条价格
    //   var c = Number(this.customCost);
    //   firstArr.forEach(ele => {
    //     // 获取公式中z、w、c的位置
    //     let zIndex = ele.formula.indexOf('z');
    //     let wIndex = ele.formula.indexOf('w');
    //     let cIndex = ele.formula.indexOf('c');

    //     // 不能同时存在z和c
    //     if(zIndex>-1 && cIndex>-1){
    //       this.$Message.error('不能同时存在自定义金价和自定义金条价格');
    //       this.spinShow = false;
    //       return
    //     }
    //     // 有自定义金价
    //     if(zIndex>-1){
    //       // 有自定义银价
    //       if(wIndex>-1){
    //         let temArr = ele.formula.split("|");
    //         let gold = eval(temArr[0]).toFixed(2);
    //         let silver = eval(temArr[1]).toFixed(2);
    //         paramsArr.push({
    //           "goods_price_template_id": ele.goods_price_template_id,
    //           "gold_multiple": gold,
    //           "silver_multiple": silver,
    //           "cost_multiple":0
    //         })
    //       }else{
    //         let gold = eval(ele.formula).toFixed(2);
    //         paramsArr.push({
    //           "goods_price_template_id": ele.goods_price_template_id,
    //           "gold_multiple": gold,
    //           "silver_multiple": 0,
    //           "cost_multiple": 0
    //         })
    //       } 
    //     }
    //     // 有自定义金条价格
    //     if(cIndex>-1){
    //       // 有自定义银价
    //       if(wIndex>-1){
    //         let temArr = ele.formula.split("|");
    //         let cost = eval(temArr[0]).toFixed(2);
    //         let silver = eval(temArr[1]).toFixed(2);
    //         paramsArr.push({
    //           "goods_price_template_id": ele.goods_price_template_id,
    //           "gold_multiple": 0,
    //           "silver_multiple": silver,
    //           "cost_multiple": cost
    //         })
    //       }else{
    //         let cost = eval(ele.formula).toFixed(2);
    //         paramsArr.push({
    //           "goods_price_template_id": ele.goods_price_template_id,
    //           "gold_multiple": 0,
    //           "silver_multiple": 0,
    //           "cost_multiple": cost
    //         })
    //       }
    //     }
    //     // 只有自定义银价
    //     if(zIndex===-1 && wIndex>-1 && cIndex===-1){
    //       let silver = eval(ele.formula).toFixed(2);
    //       paramsArr.push({
    //         "goods_price_template_id": ele.goods_price_template_id,
    //         "gold_multiple": 0,
    //         "silver_multiple": silver,
    //         "cost_multiple": 0
    //       })
    //     }
    //   }
    //   allUpdate(paramsArr).then(res=>{
    //     if(res.data.code===200){
    //       this.$Message.success("更新成功");
    //       this.spinShow = false;
    //     }else{
    //       this.$Message.error('更新失败，请重试');
    //       this.spinShow = false;
    //     }
    //   })
    // }
  }
};
</script>

<style lang="less">
.about{
  padding: 10px 20px;
  position: relative;
}
.custom-wrapper{
  margin-bottom: 20px;
  margin-top: 20px;

  .input-wrapper{
    height: 50px;
    line-height: 50px;
  }
  .input{
    width: 10%;
    margin-right:60px
  }
}
.add {
  margin-top: 10px;
  text-align: right;
  padding-right: 10px;
}
.tip{
  color: #b52333;
}
</style>
